import { TFieldValues } from './types'

export const profileFormValidations = (data: TFieldValues) => {
  const errors: any = {}
  if (!data.name) errors.name = true

  if (!data.color) errors.color = true

  const profileType = data.profileType
  if (!profileType) errors.profileType = true

  return errors
}
